import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';

class KaseyaOneService {
    readonly apiBase: string = '/api/kaseyaone';

    getKaseyaOneOrgStatus(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/enabled/organization`, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    getKaseyaOneIntegrationStatus(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/organization`, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    getKaseyaOneLoginStatus(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/organization/login-status`, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    getUserKaseyaOneStatus(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/enabled/user`, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    getRedirectOrgUrl(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
        .get(`${this.apiBase}/enable/organization/url`, {
            onError: handleError,
            onSuccess: handleSuccess,
            local: true
        })
        .catch();
    }

    getRedirectOrgDisableUrl(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
        .get(`${this.apiBase}/disable/organization/url`, {
            onError: handleError,
            onSuccess: handleSuccess,
            local: true
        })
        .catch();
    }

    getRedirectUserUrl(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
        .get(`${this.apiBase}/enable/user/url`, {
            onError: handleError,
            onSuccess: handleSuccess,
            local: true
        })
        .catch();
    }

    getRedirectUserDisableUrl(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
        .get(`${this.apiBase}/disable/user/url`, {
            onError: handleError,
            onSuccess: handleSuccess,
            local: true
        })
        .catch();
    }

    getRedirectLoginUrl(loginHint: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService
        .get(`${this.apiBase}/login/url${loginHint ? '?login_hint=' + loginHint : ''}`, {
            onError: handleError,
            onSuccess: handleSuccess,
            local: true
        })
        .catch();
    }

    switchLoginKaseyaOneButton(data: {enabled: boolean}, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/organization/login-status`, data, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    enableTenantKaseyaOne(data: {code?: string, error?: string}, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/enable/organization`, data, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    disableTenantKaseyaOne(data: {code?: string, error?: string}, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/disable/organization`, data, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    enableUserKaseyaOne(data: {code?: string, error?: string}, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/enable/user`, data, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    disableUserKaseyaOne(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/disable/user`, {}, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }

    loginKaseyaOne(data: {code?: string, error?: string}, handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}/login`, data, { onError: handleError, onSuccess: handleSuccess, local: true }).catch();
    }
}

export const kaseyaOneService = new KaseyaOneService();

